var i18n = require('i18n');
var ajax = require('@enhancer/fe-util-ajax');

var util = {};

util.makeZero = function(num) {
  return num < 10 ? '0' + num : num;
}

util.format = function(time) {
  var date = new Date(time);
  return date.getFullYear() + '-' + util.makeZero(date.getMonth() + 1) + '-' + util.makeZero(date.getDate()) +
    ' ' + util.makeZero(date.getHours()) + ':' + util.makeZero(date.getMinutes()) + ':' + util.makeZero(date.getSeconds());
}

util.getCookie = function(name) {
  var i, cookie, cookieStr,
    cookies = document.cookie.split(";");

  for (i = 0; i < cookies.length; i++) {
    cookie = cookies[i];
    cookieStr = cookie.split("=");
    if (cookieStr && cookieStr[0].replace(/^(\s*)|(\s*)$/g, "") == name) {
      return decodeURI(cookieStr[1]);
    }
  }
}

util.setCookie = function(name, value, expire, domain, path, secure) {
  var date,
    str = escape(name) + "=" + escape(value);
  date = new Date();

  date.setTime(date.getTime() + expire);
  str += domain ? "; domain=" + domain : "";
  str += path ? "; path=" + path : "";
  str += expire ? "; expires=" + date.toGMTString() : "";
  str += secure ? "; secure" : "";
  document.cookie = str;
}


util.getUrlParam = function(name) {
  ///
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return r[2];
  return null;
}

$('body').append(`<div id="enhancer-util-message" style="
    position: fixed;
    top: 50%; 
    left: 50%; 
    padding: 20px;
    transform: translate(-50%, -50%); 
    border: 1px solid #ccc;
    color: #f00;
    border-radius: 3px;
    background: #fff;
    max-width: 380px;
    z-index: 100;
    display: none;
"></div>`);

util.show = function(msg, type, cb) {

  $('#enhancer-util-message').html(msg).css({
    color: type === 'error' ? '#f00' : '#000',
    display: 'block'
  });

  setTimeout(function() {
    $('#enhancer-util-message').hide();
    cb && cb();
  }, 3000);
}


util.isMobile = function(val) {
  return /^\d{11}$/.test(val)
}

util.isEmail = function(val) {
  var reg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

  return reg.test(val);
}

util.isPassword = function(val) {
  return /^.{6,20}$/.test(val);
}

util.isActiveCode = function(val) {
  return /^\d{6}$/.test(val);
}

util.countDown = function(ele) {
  var count = 60;
  ele = $(ele);

  var oldText = ele.text();
  ele.text(`${count}s ${i18n('retryMobileCode')}`);

  var timer = setInterval(function() {
    count--;
    if (!count) {
      clearInterval(timer);
      ele.prop('disabled', false);
      ele.text(oldText);
    } else {
      ele.text(`${count}s ${i18n('retryMobileCode')}`);
    }
  }, 1000);
}

var codeErrorCount = 0;
util.getActiveCode = function(ele, mobile, cb) {
  util.setCookie('v', '1');
  if (typeof mobile === 'object') {
    mobile.token = $('input[name=en_mobile_token]').val()
  } else {
    mobile = {
      mobile: mobile,
      token: $('input[name=en_mobile_token]').val()
    }
  }
  ele.prop('disabled', true);
  ajax({
    url: `/sms/code`,
    data: mobile
  }, function(res) {
    if (res.success) {
      util.countDown(ele);
    } else {
      ele.prop('disabled', false);
      if (res.code == 1000 || res.code == 1010 || res.code == 1011 || res.code == 1012) {
        codeErrorCount++;
        util.show(res.message);
        if (codeErrorCount > 3) {
          cb && cb();
        }
      } else {
        cb && cb();
      }
    }
  }, function(err) {
    ele.prop('disabled', false);
  });
}


util.getScript = function (url, cb) {
  var script = document.createElement("script");
  script.src = url;
  script.crossOrigin = "anonymous";
  script.onload = cb;
  document.body.appendChild(script);
}

module.exports = util;


// WEBPACK FOOTER //
// ./src/app/util.js